"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import SearchBox from "../module/SearchBox";
import Login from "../module/Modal/Login";
import Drawer from "../module/Drawer";
import Dropdowns from "../module/DropDown";
import { navItems } from "@src/constants/_navItems";
import { useAuth } from "@src/contexts/AuthContext";
import { useCart } from "@src/contexts/CartContext";
import { cartIcon, LoginImg } from "@public/icons";
import { marvelLifeImage, marvelLifeStiky } from "@public/images";
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotificationBar from "../template/Home/NotificationBar";

export default function Navbar() {
  const { cartItems = [] } = useCart();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const { token } = useAuth();

  const router = useRouter();

  const pathname = usePathname();

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleCartClick = () => {
    if (token) {
      router.push("/cart");
    } else {
      toast.warning("لطفاً ابتدا وارد حساب کاربری شوید.");
    }
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <nav className="container mx-auto w-full bg-white">
        <div className="flex items-center justify-between px-6 py-6 md:px-24 md:py-8">
          <button
            className="relative block h-6 w-6 text-gray-600 xl:hidden"
            onClick={handleDrawerToggle}
            aria-label="Toggle navigation"
          >
            <span
              className={`absolute block h-[2px] w-full transform bg-current transition-all duration-300 ease-in-out ${
                isDrawerOpen ? "top-1/2 left-0 rotate-45" : "top-0 left-0"
              }`}
            ></span>
            <span
              className={`absolute block h-[2px] w-full transform bg-current transition-all duration-300 ease-in-out ${
                isDrawerOpen ? "opacity-0" : "top-2 left-0"
              }`}
            ></span>
            <span
              className={`absolute block h-[2px] w-full transform bg-current transition-all duration-300 ease-in-out ${
                isDrawerOpen ? "top-1/2 left-0 -rotate-45" : "top-4 left-0"
              }`}
            ></span>
          </button>

          <div className="flex items-center gap-x-5">
            <Link href="/" className="flex justify-center">
              {!isMobile ? (
                <Image
                  src={marvelLifeImage}
                  alt="لوگوی مارول"
                  className="hidden w-32 md:block"
                  priority={!isMobile}
                />
              ) : (
                <Image
                  src={marvelLifeStiky}
                  alt="لوگوی مارول (موبایل)"
                  className="block w-28 md:hidden"
                  priority={isMobile}
                  quality={80}
                />
              )}
            </Link>

            <div className="hidden xl:block">
              <SearchBox />
            </div>
          </div>

          <div className="flex items-center gap-x-4 md:gap-x-5">
            <Link download href="/MarvelLife.apk" className="hover:bg-skyBlue hidden rounded-lg border bg-white px-4 py-2 text-sm font-semibold text-blue-600 transition duration-300 ease-in-out hover:bg-blue-600 hover:text-white lg:block">
              دانلود اپلیکیشن
            </Link>

            {token ? (
              <Dropdowns />
            ) : (
              <button
                onClick={handleModalToggle}
                className="flex cursor-pointer items-center gap-x-2 rounded-lg"
              >
                <Image
                  priority
                  width={24}
                  height={24}
                  className="block size-6 md:hidden"
                  src={LoginImg}
                  alt="LoginImg"
                />
                <span className="hidden text-sm md:block">ورود / ثبت‌نام</span>
              </button>
            )}

            <div className="hidden h-10 w-[1px] bg-[#E0E9EF] xl:flex" />

            <div onClick={handleCartClick} className="cursor-pointer">
              <div>
                <Image src={cartIcon} alt="سبد خرید" width={24} height={24} />
              </div>
              {cartItems?.items?.length > 0 ? (
                <div className="absolute top-6 left-10 h-5 w-5 rounded-full bg-[#c82c3c] pt-0.5 text-center text-xs text-white lg:top-11 lg:left-28">
                  {cartItems.items.length}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div>
          <div className="hidden flex-row items-center justify-between px-6 lg:px-24 xl:flex">
            <div className="flex items-center gap-x-6 text-gray-700">
              {navItems.map((nav) => {
                const isActive = pathname === nav.href;
                return (
                  <Link className="h-[34px]" key={nav.href} href={nav.href}>
                    <p
                      className={`py-1 text-nowrap transition duration-300 ease-in-out ${
                        isActive
                          ? "border-skyBlue text-skyBlue border-b-2"
                          : "hover:border-skyBlue hover:text-skyBlue hover:border-b-2"
                      }`}
                    >
                      {nav.name}
                    </p>
                  </Link>
                );
              })}
            </div>
          </div>
          {/* <NotificationBar /> */}
        </div>

        <div
          className={`fixed right-0 left-0 z-50 transition-all duration-500 ${
            isSticky
              ? "opacity-100 lg:top-0 lg:translate-y-0 lg:bg-white lg:py-3 lg:shadow-md"
              : "lg:top-[-100px] lg:translate-y-[-10px] lg:opacity-0"
          }`}
        >
          <div className="hidden flex-row items-center justify-between px-6 lg:px-24 xl:flex">
            <div className="flex items-center gap-x-8 text-gray-700">
              {navItems.map((nav) => {
                const isActive = pathname === nav.href;
                return (
                  <Link key={nav.href} href={nav.href}>
                    <p
                      className={`pb-1 text-nowrap transition duration-300 ease-in-out ${
                        isActive
                          ? "border-skyBlue text-skyBlue border-b-2"
                          : "hover:border-skyBlue hover:text-skyBlue hover:border-b-2"
                      }`}
                    >
                      {nav.name}
                    </p>
                  </Link>
                );
              })}
            </div>

            <div
              className={`transition-all duration-500 ${
                isSticky ? "scale-100 opacity-100" : "scale-90 opacity-0"
              }`}
            >
              {isSticky && <Image className="w-28" src={marvelLifeStiky} alt="marvelLifeStiky" />}
            </div>
          </div>
        </div>
      </nav>

      <Login isOpen={isModalOpen} handleModalToggle={handleModalToggle} />

      <Drawer
        title={marvelLifeImage}
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        size="w-3/5"
        position="right"
      >
        <div className="flex flex-col gap-y-4">
          {navItems.map((nav) => {
            const isActive = pathname === nav.href;

            return (
              <Link key={nav.href} href={nav.href}>
                <p
                  onClick={handleDrawerToggle}
                  className={`hover:text-skyBlue w-fit text-gray-700 ${
                    isActive ? "border-skyBlue text-skyBlue border-b-2" : ""
                  }`}
                >
                  {nav.name}
                </p>
              </Link>
            );
          })}
        </div>
        <div className="mt-10 flex">
          <Link download href="/MarvelLife.apk"
            className="bg-button-gradient transform rounded-lg px-8 py-3 text-center text-white shadow-lg transition-all duration-300 hover:scale-105 hover:from-teal-500 hover:to-blue-600 hover:shadow-2xl"
            onClick={handleDrawerToggle}
          >
            دانلود اپلیکیشن
          </Link>
        </div>
      </Drawer>
    </>
  );
}
